import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import './Serviceinfo.css'
import Back from "../../imgs/back2.png";
import Computer from "../../imgs/computer.png";
const Serviceinfo = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const tohome = () => {
        navigate('/Dashboard');
    }

    return (
        <div className='serviceinfo'>
            <div className="serviceinfowhitebox">
                <div className="toprowservices">
                    <div className="topleft">
                        <img onClick={tohome} src={Back} alt="" />
                        <div className="headingservices">
                            <span>{state.head}</span>
                            <div className="iniq">
                                INIQTEST
                            </div>
                        </div>
                    </div>
                    <div className="topright">
                        <img src={Computer} alt="" />

                    </div>

                </div>
                <div className="info">
                    <span>{state.info}</span>
                </div>
            </div>
        </div>
    )
}

export default Serviceinfo
